import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  ${({ theme }) => css`
    margin: 10rem 5rem 0 35rem;

    @media (min-width: 1600px) {
      margin: 8rem 5rem 0 35rem;
    }

    /* posição navegação */
    @media only screen and (max-width: 480px) {
      margin: 0 1rem 0 1rem;
    }
    @media only screen and (max-width: 978px) {
      margin: 0 1rem 0 1rem;
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    color: ${theme.colors.gray};
    font-size: ${theme.font.sizes.medium};
    line-height: 1.2;

    @media only screen and (max-width: 500px) {
      font-size: 1.2rem;
    }
  `}
`;

export const AddNew = styled.div`
  ${({ theme }) => css`
    margin-right: 0;
    display: flex;
    align-items: center;
    font-weight: 500;
    color: ${theme.colors.lineBlue};
    font-size: ${theme.font.sizes.large};
    cursor: pointer;
    line-height: 1.2;

    @media (min-width: 501px) {
      padding-bottom: 0.8rem;
    }

    p {
      margin-right: 1rem;
      font-size: 1.5rem;

      @media only screen and (max-width: 500px) {
        margin-left: -8.2rem;
        font-size: 1.3rem;
      }
    }
  `}
`;

export const ImPlus = styled.div`
  margin-bottom: 5px;
`;

export const Header = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    border-bottom: 0.3rem solid ${theme.colors.lineBlue};

    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    @media only screen and (max-width: 998px) {
      margin-top: 8rem;
    }
  `}
`;

export const BoxUser = styled.div`
  ${({ theme }) => css`
    width: 80%;
    display: flex;
    align-items: center;
    padding-bottom: 0.8rem;

    ${Description} {
      color: ${theme.colors.gray};
      font-style: normal;
    }

    @media (min-width: 1600px) {
      margin-top: 1.8rem;
      ${Description} {
        font-size: ${theme.font.sizes.medium};
      }
    }
  `}
`;

export const Image = styled.img`
  margin-right: 1.5rem;
  height: 4rem;

  @media (min-width: 1600px) {
    height: 4rem;
  }

  @media only screen and (max-width: 500px) {
    height: 2.8rem;
  }
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    font-family: "Roboto";
    font-size: ${theme.font.sizes.large};
    color: ${theme.colors.grayFour};
    font-weight: bold;

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.large};
    }
    @media only screen and (max-width: 500px) {
      font-size: 1.4rem;
    }
  `}
`;

export const Content = styled.div`
  max-width: 70%;
  margin: 0 auto;
  margin-top: 4rem;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-top: 6rem;
  width: 90%;

  > button {
    margin-left: 1.8rem;
  }

  @media (min-width: 1600px) {
    margin-top: 5rem;
  }
`;

export const InputBox = styled.div`
  ${({ columns = "2fr 1fr", gap = "2rem" }) => css`
    display: grid;
    grid-template-columns: ${columns};
    gap: ${gap};
    width: 90%;
  `}
`;

export const SubTitle = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.gray};
    margin-top: 4rem;
    display: flex;
    flex-direction: column;
    font-family: Roboto;
    font-weight: 500;

    &::after {
      content: "";
      display: block;
      width: 90%;
      height: 0.3rem;
      border-bottom: 2px solid #a1a1a1;

      margin-top: 0.1rem;
    }

    @media (min-width: 1600px) {
      font-size: 2rem;
      margin-top: 6rem;
    }
  `}
`;
